import { gateway } from "../../../../gateway";
import {
  IBillingSubscriptionsApiResponse,
  IBillingSubscriptionsPaginatedData,
  IGetBillingSubscriptionsQueryParams,
} from "../interfaces/billingSubscriptions.interface";

export const getBillingSubscriptionsAction = async ({
  page = 1,
  pageSize = 10,
  order = "DESC",
  orderBy = "expDate",
  clientName,
  status,
}: IGetBillingSubscriptionsQueryParams = {}): Promise<IBillingSubscriptionsPaginatedData> => {
  const token = sessionStorage.getItem("token");

  const params: Record<string, any> = {
    page,
    pageSize,
    order,
    orderBy,
  };

  if (status && status !== "all") {
    params.status = status;
  }

  if (clientName && clientName.trim()) {
    params.clientName = clientName.trim();
  }

  const response = await gateway.get<IBillingSubscriptionsApiResponse>("/subscriptions/billing", {
    params,
    headers: {
      Authorization: `${token}`,
    },
  });

  const resData = response.data;

  if (resData && resData.data) {
    return {
      page: resData.data.page ?? page,
      pageSize: resData.data.pageSize ?? pageSize,
      totalItems: resData.data.totalItems ?? 0,
      totalPages: resData.data.totalPages ?? 0,
      items: resData.data.items ?? [],
    };
  }

  return {
    page,
    pageSize,
    totalItems: 0,
    totalPages: 0,
    items: [],
  };
};
